import { CircleLayer, FillLayer } from "react-map-gl";
import { Theme } from "@mui/material/styles";

export const getSectorBaseLayer = (theme: Theme): FillLayer => {

  return {
    id: "sector-base",
    type: "fill",
    "source-layer": "postal_sector_test",
    minzoom: 4,
    paint: {
      "fill-outline-color": "rgba(33,43,58,0.4)",
      "fill-color": [
        "match",
        ["feature-state", "category"],
        "Infrequent",
        theme.palette.gradient[0],
        "Occasional",
        theme.palette.gradient[1],
        "Regular",
        theme.palette.gradient[2],
        "Core",
        theme.palette.gradient[3],
        "Local",
        theme.palette.gradient[4],
        "rgba(33,43,58,0)"
      ],
      "fill-opacity":
      [
        "case",
        ["==", ["feature-state", "score"], null],
        0,
        ["case", ["<", ["feature-state", "score"], 0], 0, 1],
      ],
    }
  }
}

export const getPointLayer = (theme: Theme): CircleLayer => {
  return {
    id: 'site-points',
    type: 'circle',
    paint: {
      'circle-radius': 8,
      'circle-color': theme.palette.secondary.main
    }
  }
}
